import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class FieldsApi extends ApiModule {
	constructor() {
		super(ModulesMap.FIELDS, {
			entity: 'fields',
		})
	}
}
